type ProcessType = {
    name: string;
    icon: string;
    background: string;
    textColor: string;
    outline: string;
    overlay: string;
    titleColor: string;
    numberof: number | null;
};

export default ProcessType;

export const ProcessTypeOptions = [
    {
        name: "None",
        icon: "",
        background: "white",
        textColor: "black",
        outline: "#d1d1e0",
        overlay: "rgba(0, 0, 0, 0.0)",
        titleColor: "#000000",
    },
    {
        name: "Complaint",
        icon: " ri-file-paper-fill",
        background: "linear-gradient(45deg,  #000099 30%, #8080ff 90%)",
        textColor: "white",
        outline: "1px solid blue",
        overlay: "rgba(0, 0, 255, 0.5)",
        titleColor: "#0000FF",
    },
    {
        name: "Summons",
        icon: "ri-user-fill",
        background: "linear-gradient(45deg,  #cc3300 30%, #ffb3d9 90%)",
        textColor: "white",
        outline: "1px solid red",
        overlay: "rgba(255, 0, 0, 0.5)",
        titleColor: "#FF0000",
        numberof: 1,
    },
    {
        name: "Order",
        icon: "ri-scales-fill",
        background: "linear-gradient(45deg,  #00b300 30%, #99ff99 90%)",
        textColor: "black",
        outline: "1px solid green",
        overlay: "rgba(0, 255, 0, 0.5)",
        titleColor: "#00FF00",
    },
    {
        name: "Exhibit",
        icon: "ri-gallery-upload-fill",
        background: "linear-gradient(45deg,  #ffcc00 30%, #ffff99 90%)",
        textColor: "black",
        outline: "1px solid cyan",
        overlay: "rgba(0, 255, 255, 0.5)",
        titleColor: "#00FFFF",
    },
    {
        name: "Motion",
        icon: "ri-chat-new-fill",
        background: "linear-gradient(45deg,  #ff6600 30%, #ffcc99 90%)",
        textColor: "black",
        outline: "1px solid orange",
        overlay: "rgba(255, 165, 0, 0.5)",
        titleColor: "#FF9900",
        numberof: 1,
    },
    {
        name: "Notice",
        icon: "ri-feedback-fill",
        background: "linear-gradient(45deg,  #ff0000 30%, #ff9999 90%)",
        textColor: "white",
        outline: "1px solid pink",
        overlay: "rgba(255, 0, 255, 0.5)",
        titleColor: "#FF00FF",
        numberof: 1,
    },
    {
        name: "DO NOT EFILE",
        icon: " ri-chat-delete-fill",
        background: "linear-gradient(45deg,  #6600ff 30%, #9999ff 90%)",
        textColor: "white",
        outline: "1px solid black",
        overlay: "rgba(0, 0, 0, 0.75)",
        titleColor: "#990099",
    },
] as ProcessType[];
